import { render, staticRenderFns } from "./repeatsettings.vue?vue&type=template&id=63eabc5e&scoped=true&"
import script from "./repeatsettings.vue?vue&type=script&lang=js&"
export * from "./repeatsettings.vue?vue&type=script&lang=js&"
import style0 from "./repeatsettings.vue?vue&type=style&index=0&id=63eabc5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63eabc5e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/contactum-new/contactum-new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63eabc5e')) {
      api.createRecord('63eabc5e', component.options)
    } else {
      api.reload('63eabc5e', component.options)
    }
    module.hot.accept("./repeatsettings.vue?vue&type=template&id=63eabc5e&scoped=true&", function () {
      api.rerender('63eabc5e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/admin/components/pro/field-template/repeatsettings.vue"
export default component.exports